import { RelatorioIdEnum } from "core/features/relatorios/typings";
export interface GrupoRelatorioItem {
  id: string;
  nome: string;
}

export interface RelatorioItem {
  id: string;
  nome: string;
  baseUrl: string;
  pdfUrl: string;
  grupoRelatorioId: string;
}

export interface ListaRelatorioPrestacaoContasResponse {
  id: string;
  nome: string;
  observacao?: string;
  dataInicio?: string | null;
  dataFim?: string | null;
}

export enum TipoItemRelatorioPrestacaoContas {
  Capa = "capa",
  Relatorio = "relatorio",
  PdfExterno = "pdf-externo",
}

export enum TipoFiltroDataRelatorioPrestacaoContas {
  TodosOsMeses = "todos-os-meses",
  MesAtual = "mes-atual",
  MesAnterior = "mes-anterior",
  DoisMesesAtras = "dois-meses-atras",
  ProximoMes = "proximo-mes",
  AnoAtual = "ano-atual",
  AnoAnterior = "ano-anterior",
  ProximoAno = "proximo-ano",
  MesEspecifico = "mes-especifico",
}

export enum CapaOrientacaoEnum {
  Retrato = "retrato",
  Paisagem = "paisagem",
}

export interface RelatorioPrestacaoContasItem {
  id: string;
  relatorioPrestacaoContasId: string;
  relatorioId: RelatorioIdEnum | null;
  tipoItem: TipoItemRelatorioPrestacaoContas;
  tipoFiltroData: TipoFiltroDataRelatorioPrestacaoContas;
  titulo: string | null;
  orientacao: CapaOrientacaoEnum | null;
  parametros: {
    filtrosAdicionais: Record<string, any>;
    colunas: string[];
    assinaturas: {
      cargoId?: string;
      cargoNome?: string;
      pessoaId?: string;
      pessoaNome?: string;
      addTime?: number;
    }[];
  };
  ordem: number;
  relatorioPdfUrl: string | null;
  arquivoId: string | null;
  arquivo: {
    id: string;
    nome: string;
    referencia: string;
    mimetype: string;
  } | null;
}

export interface RelatorioPrestacaoContasForm {
  id?: string;
  nome: string;
  observacao?: string;
  tipoPeriodo?: "sempre" | "mes" | "periodo";
  dataInicio?: string | null;
  dataFim?: string | null;
  items: Partial<RelatorioPrestacaoContasItem>[];
}
